// extracted by mini-css-extract-plugin
module.exports = {"inlineMath":"styles_inlineMath__2dRCI"};